<div class="columns">
  <div class="column">
    <div class="p-y-xl spoiler-card">
      <span class="tag is-link">Spoiler alert</span>
      <p class="title is-2">{{ spoiler.content }}</p>
    </div>
  </div>
</div>
